module.exports = __webpack_public_path__ + "img/AvenyTWEB.a709eeb5.svg";